module.exports = __webpack_public_path__ + "static/media/copy-gray-icon.837b8caa.svg";